import {
    Features,
    useFeatureFlagValue,
} from '@experiences/feature-flags';

import useIsDedicated from './useIsDedicated';
import useIsOnPrem from './useIsOnPrem';

const useIsClusterHealthPortalAvailable = () => {
    const isEnabled = useFeatureFlagValue(Features.EnableASClusterHealthPortal.name);
    const isOnPrem = useIsOnPrem();
    const isDedicated = useIsDedicated();

    return isEnabled && isOnPrem && !isDedicated;
};

export default useIsClusterHealthPortalAvailable;
